import { render, staticRenderFns } from "./ImagesManage.vue?vue&type=template&id=c2df8e4a&"
import script from "./ImagesManage.vue?vue&type=script&lang=js&"
export * from "./ImagesManage.vue?vue&type=script&lang=js&"
import style0 from "./ImagesManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports